import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Button } from '@startengine/design-system.ui.button';

import { useParams } from 'next/navigation';
import Update from './Update';
import useIsMobile from 'hooks/useIsMobile';
import usePaginatedOfferingUpdatesService from 'hooks/usePaginatedOfferingUpdatesService';

const Updates = () => {
  const isMobile = useIsMobile();
  const param = useParams();

  const {
    data: allPaginatedOfferingUpdatesService,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = usePaginatedOfferingUpdatesService({
    getAll: true,
    recentlyApproved: false,
    slug: param?.slug?.[0],
  });

  const { updateMap } = usePaginatedOfferingUpdatesService({
    recentlyApproved: true,
    getAll: true,
    slug: param?.slug?.[0],
  });

  const updatesToRender = allPaginatedOfferingUpdatesService?.pages?.flatMap((page) =>
    page?.list
      ?.filter((update) => !updateMap?.[update.id])
      ?.map((update) => (
        <Grid item xs={12} key={update.id} pb="24px">
          <Update update={update} />
        </Grid>
      )),
  );

  if (!updatesToRender?.length && hasNextPage) {
    fetchNextPage();
  }

  return (
    <Grid
      data-testid="updates-section"
      data-cy="updates-section"
      position="relative"
      id="updates-section"
    >
      <Grid container spacing={3}>
        <Grid item container spacing={8}>
          {(updatesToRender?.length || isFetching || isFetchingNextPage) && (
            <>
              <Grid item container xs={12} spacing={1}>
                <Grid item xs={12}>
                  <Typography variant={isMobile ? 'h5Caps' : 'h4'} data-cy="all-updates-title">
                    ALL UPDATES
                  </Typography>
                  <div id="anchor-updates" />
                </Grid>
              </Grid>
              <Grid item container xs={12} spacing={4} pt={isMobile && '20px !important'}>
                {updatesToRender}
              </Grid>
            </>
          )}
        </Grid>
        <Grid item container spacing={8}>
          {isFetching || isFetchingNextPage
            ? [1, 2, 3].map((index) => (
                <Grid item xs={12} key={`update-${index}`}>
                  <Update loading />
                </Grid>
              ))
            : null}
        </Grid>
        {hasNextPage && (
          <Grid item xs={12} container justifyContent="center">
            <Button
              data-cy="updates-show-more-button"
              onClick={() => {
                fetchNextPage();
              }}
              color="primary"
              variant="contained"
              width="lg"
              disabled={!hasNextPage}
            >
              Show More Updates
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default Updates;
